import React from "react"
import styled from "styled-components"
import MuxPlayer from "@mux/mux-player-react"
import colors from "@constants/colors"

const VideoWrapper = styled.div<{
  hideControls?: boolean
  fullWidth?: boolean
  disablePlayback?: boolean
}>`
  width: 100%;
  height: 100%;

  > * {
    height: 100%;
    --controls: ${({ hideControls }) => hideControls && "none"};
    --media-object-fit: cover;
    --media-object-position: center;
    object-fit: contain;
    object-position: center;
    aspect-ratio: ${({ fullWidth }) => (fullWidth ? "16/9" : "1/1")};
  }

  > mux-player::part(center play button) {
    display: flex;
    pointer-events: ${({ disablePlayback }) =>
      disablePlayback ? "none" : "auto"};
    background-color: ${colors.mediumDarkGray};
  }
`

interface DesktopPDPMuxPlayerProps {
  autoplayVideo?: boolean
  fullWidth?: boolean
  hideControls?: boolean
  loopVideo?: boolean
  muxVideo?: {
    title: string
    video: {
      ratio: string
      ready: boolean
      assetId: string
      version: number
      duration: number
      audioOnly: boolean
      created_at: number
      playbackId: string
      max_stored_frame_rate: number
      max_stored_resolution: string
    }
  }
  onPlaying?: (isMobile: boolean) => void
  onEnded?: () => void
  disablePlayback?: boolean
}

export default function DesktopPDPMuxPlayer({
  autoplayVideo = false,
  fullWidth = false,
  hideControls = false,
  loopVideo = true,
  muxVideo,
  onPlaying,
  onEnded,
  disablePlayback = false,
}: DesktopPDPMuxPlayerProps) {
  const videoPlaybackId = muxVideo?.video.playbackId

  return (
    <VideoWrapper
      hideControls={hideControls}
      fullWidth={fullWidth}
      disablePlayback={disablePlayback}
    >
      <MuxPlayer
        autoPlay={autoplayVideo ? "muted" : false}
        loop={loopVideo}
        playbackId={videoPlaybackId}
        streamType="on-demand"
        accentColor={colors.brandOrange}
        nohotkeys={hideControls}
      />
    </VideoWrapper>
  )
}
